/*
 * Copyright 2019 FedEx
 */
export const environment = {
  production: true,
  captchaClientID: 'w-888731',
  baseUrl: 'https://apitest1.emea.fedex.com/easycustoms/preprod/v1',
  docUploadContext:'/docupload',
  nucaptchaContext: '/nucaptcha',
  FAQ_URL: 'https://ask.fedex.com/help/',
  LOGO_REDIRECT_PART_1: 'https://wwwtest.fedex.com/',
  LOGO_REDIRECT_PART_2: '/home.html',
  TRACKING_URL_PART1: 'https://www.fedex.com/apps/fedextrack/?action=track&tracknumbers=',
  TRACKING_URL_PART2: '&locale=',
  TRACKING_URL_PART3: '&cntry_code=fcl',
  CUSTOMER_SUPPORT_URL_PART1: 'https://wwwtest.fedex.com/',
  CUSTOMER_SUPPORT_URL_PART2: '/customer-support.html',
  WRITE_TO_FEDEX_URL_PART1: 'https://wwwtest.fedex.com/',
  WRITE_TO_FEDEX_URL_PART2: '/customer-support/write-to-fedex.html',
  PRIVACY_POLICY_URL_1: 'https://wwwtest.fedex.com/',
  PRIVACY_POLICY_URL_2: '/privacy-policy.html',
  APPLY_EORI_LOCAL_GOVT:'https://www.gov.uk/eori',
  CLIENT_ID_EC_KNIGHT : '54b7fc2d-a4dd-4721-b175-2cdd09411a4e',
  CLIENT_SECRET_EC_KNIGHT : '2e21721f-6646-4115-bacc-acb6e0a9a2dc',
  OAUTH_TOKEN_EC_KNIGHT: 'https://api.emea.fedex.com/auth/oauth/v2/token',
  GET_AWB_DETAILS_API_URL : '/clearance/',
  SUBMIT_REASON_CODE : '/clearance/',
  INITIALIZE_CAPTCHA_API_URL : '/fedexNDS/init',
  VALIDATE_CAPTCHA_API_URL : '/fedexNDS/validate',
  POST_FILE_URL : '/clearance/',
  GET_DOCUMENT: '/shipment-docs',  
  GET_EDM_DOCUMENT: '/shipment-edm-docs',
  GET_CTRY_BASED_REASON_CODE: '/country-reason-config/findReasonsByCountry/',
  API_KEY: 'l7xx4bb3a29512df4661b8a4b6b2aa5c7a42',

};